import * as o from "react";
import a from "../lib/SSRBase.es.js";
import m from "../defs/CaretDown.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "CaretDownIcon";
const c = e;
export {
  c as CaretDown,
  e as CaretDownIcon
};
